
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/browse/stocks/[alphabet]",
      function () {
        return require("private-next-pages/browse/stocks/[alphabet].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/browse/stocks/[alphabet]"])
      });
    }
  